import BaseRequest from "./BaseRequest";
import SingletonBootConfig from "./SingletonBootConfig";
import { POST_ATTACHMENTS, setPathWS } from "../constant";
export default class ChatRequest {
  static SendMsg = async (newMsg, session,type) => {
    console.log('send type:',type);
    let path = SingletonBootConfig.getInstance().getExternalChat();
    return BaseRequest.GetXMLRequest(path, {
      process: 2,
      message: newMsg,
      random: Math.floor(Math.random() * 1000 + 1),
      type: type,
      session: session
    });
  };

  static ListenMsg = async (isWriting, session) => {
    let path = SingletonBootConfig.getInstance().getExternalChat();
    return BaseRequest.GetXMLRequest(path, {
      process: 4,
      isWriting: isWriting,
      random: Math.floor(Math.random() * 1000 + 1),
      session: session
    });
  };

  static SendEmail = async (session, message, email) => {
    let path = SingletonBootConfig.getInstance().getExternalChat();

    const data = new FormData();
    data.append("process", "7");
    data.append("type", "2");
    data.append("random", Math.floor(Math.random() * 1000 + 1).toString());
    data.append("email", email);
    data.append("message", message);
    data.append("session", session);

    return fetch(path, {
      method: "POST",
      body: data
    });
  };

  static onUploadAttachment = async (id,chatId, fileName, file) => {
    console.log(`onUploadAttachment(id:${id}, fileName:${fileName}), file:${file}`);
    
    try {
      const formData = new FormData();
      formData.append("fileName", file);
      formData.append("MultimediaType", "1");
      formData.append("UserId", id);
      formData.append("InboundId", "1");
      formData.append("ConversationId", chatId);
      formData.append("NewFileName", fileName);
      return fetch(setPathWS() + POST_ATTACHMENTS, {
        method: "POST",
        body: formData,
        mode: "cors",
      });
    } catch (error) {
      console.log(error);
    }
  };  
}
